import { useState, useEffect } from 'react';

export const useDesktopNotifications = () => {
  const [permission, setPermission] = useState(Notification.permission);

  useEffect(() => {
    const handler = () => setPermission(Notification.permission);
    navigator.permissions.query({ name: 'notifications' }).then((status) => {
      status.onchange = handler;
    });
  }, []);

  const requestPermission = () => {
    if (permission !== 'granted') {
      Notification.requestPermission().then((newPermission) => {
        setPermission(newPermission);
      });
    }
  };

  const showNotification = (title, options) => {
    if (permission !== 'granted') return;

    new Notification(title, options);
  };

  return { permission, requestPermission, showNotification };
};
